import { render } from "./AuthAdmin.vue?vue&type=template&id=4f63e0e4&scoped=true&lang=pug"
import script from "./AuthAdmin.vue?vue&type=script&lang=js"
export * from "./AuthAdmin.vue?vue&type=script&lang=js"

import "./AuthAdmin.vue?vue&type=style&index=0&id=4f63e0e4&lang=sass&scoped=true"

import exportComponent from "D:\\Front\\project\\valeriya.artist\\valeriya.artist.admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f63e0e4"]])

export default __exports__